import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../utils/API_URL";

const initialState = {
  user: null,
  isAuthenticated: false,
  isRoot: false,
  assetCode: "",
  storage: [],
  graphStatus: false,
  kpiStatus: false,
  ganttStatus: false,
  summaryItemStatus: false,
  summaryLineStatus: false,
  summaryResultStatus: false,
  simResult: false,
  lineSummaryStatus: false,
  planWeek: false,
  month: 1,
  popStatus: false,
  popShowing: "",
  simulation1: false,
  simulation2: false,
  workerStatus: false,
  chattingStatus: {
    type: "",
    status: null,
  },
  qrData: null,
  dateSystemStatus: false,
  disasterStatus: {
    isActive: false,
    isAllChecked: false,
  },
  svResultStatus: false, // SV 결과 분석 메뉴 상태
  productivityStatus: false, // 생산성 현황 메뉴 상태
  dtiInfoStatus: false, // 말풍선 메뉴 상태
  dtInfoMenuOpen: false, // DT 말풍선 서브메뉴 열림 상태
  dtInfoMode: 0, // DT 말풍선 현재 모드 (단일 선택, 기본=0)
};

export const fetchStorage = createAsyncThunk("auth/fetchStorage", async () => {
  const res = await axios.get(API_URL + "/data/getMasterAsset");
  const final = [...new Set(res.data[0].map((item) => item.asset_code))];
  return final;
});

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.qrData = null;
    },
    setAssetCode(state, action) {
      state.assetCode = action.payload;
    },
    setGraphStatus(state, action) {
      const newStatus = action.payload;
      if (newStatus && state.disasterStatus.isActive) {
        state.graphStatus = false; // 재난 중 활성화 시도 시 강제 비활성화
      } else {
        state.graphStatus = newStatus;
        if (newStatus) {
          state.productivityStatus = false; // 생산성 현황 비활성화
        }
      }
    },
    setMonth(state, action) {
      state.month = action.payload;
    },
    setKpiStatus(state, action) {
      state.kpiStatus = action.payload;
    },
    setGanttStatus(state, action) {
      state.ganttStatus = action.payload;
    },
    setPopStatus(state, action) {
      state.popStatus = action.payload;
    },
    setPopShowing(state, action) {
      state.popShowing = action.payload;
    },
    setChattingStatus(state, action) {
      state.chattingStatus = action.payload;
    },
    setSummaryItemStatus(state, action) {
      state.summaryItemStatus = action.payload;
    },
    setSummaryLineStatus(state, action) {
      state.summaryLineStatus = action.payload;
    },
    setSummaryResultStatus(state, action) {
      state.summaryResultStatus = action.payload;
    },
    setLineSummaryStatus(state, action) {
      state.lineSummaryStatus = action.payload;
    },
    setSimResult(state, action) {
      state.simResult = action.payload;
    },
    setPlanWeek(state, action) {
      state.planWeek = action.payload;
    },
    setSimulation1(state, action) {
      state.simulation1 = action.payload;
    },
    setSimulation2(state, action) {
      state.simulation2 = action.payload;
    },
    setWorkerStatus(state, action) {
      state.workerStatus = action.payload;
    },
    setQrData: (state, action) => {
      state.qrData = action.payload;
    },
    setDateSystemStatus: (state, action) => {
      state.dateSystemStatus = action.payload;
    },
    setDisasterStatus(state, action) {
      state.disasterStatus = action.payload;
      if (action.payload.isActive) {
        state.graphStatus = false;
        state.productivityStatus = false;
      }
    },
    setSvResultStatus: (state, action) => {
      // SV 결과 분석 메뉴 상태 변경
      state.svResultStatus = action.payload;
    },
    setProductivityStatus: (state, action) => {
      const newStatus = action.payload;
      if (newStatus && state.disasterStatus.isActive) {
        state.productivityStatus = false; // 재난 중 활성화 시도 시 강제 비활성화
      } else {
        state.productivityStatus = newStatus;
        if (newStatus) {
          state.graphStatus = false; // 그래프 비활성화
        }
      }
    },
    setDtiInfoStatus: (state, action) => {
      state.dtiInfoStatus = action.payload;
    },
    setDtInfoMenuOpen: (state, action) => {
      state.dtInfoMenuOpen = action.payload;
    },
    setDtInfoMode: (state, action) => {
      // 단일 선택 모드 유지 (향후 배열로 확장 가능)
      state.dtInfoMode = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchStorage.fulfilled, (state, action) => {
      state.storage = action.payload;
    });
  },
});

export const {
  setUser,
  logout,
  setAssetCode,
  setGraphStatus,
  setKpiStatus,
  setMonth,
  setPopStatus,
  setPopShowing,
  setGanttStatus,
  setChattingStatus,
  setSummaryItemStatus,
  setSummaryLineStatus,
  setSummaryResultStatus,
  setLineSummaryStatus,
  setSimResult,
  setPlanWeek,
  setSimulation1,
  setSimulation2,
  setWorkerStatus,
  setQrData,
  setDateSystemStatus,
  setDisasterStatus,
  setSvResultStatus, // SV 결과 분석 메뉴 상태 변경 export
  setProductivityStatus,
  setDtiInfoStatus,
  setDtInfoMenuOpen,
  setDtInfoMode,
} = authSlice.actions;
export default authSlice.reducer;